export interface UserLike {
  userId: string;
  email: string;
  name: string | null | undefined;
  role: string;
}

/**
 * Filter users for the admin user list.
 * - Excludes super_admin users
 * - Case-insensitive search against email and name
 * - Role filter: "all" shows all non-super_admin, specific role filters to match
 */
export function filterUsers<T extends UserLike>(
  users: T[],
  searchQuery: string,
  roleFilter: string,
): T[] {
  const q = searchQuery.trim().toLowerCase();

  return users
    .filter((u) => u.role !== "super_admin")
    .filter((u) => {
      const matchesSearch =
        !q || u.email.toLowerCase().includes(q) || (u.name ?? "").toLowerCase().includes(q);
      const matchesRole = roleFilter === "all" || u.role === roleFilter;
      return matchesSearch && matchesRole;
    });
}
